// The character ranges this counts as CJK:
// - 一-龥 CJK Unified Ideographs, the common Han range
// - ︰-ﾠ CJK Compatibility Forms, and the halfwidth and fullwidth forms after it
//
// NOTE: the second range also covers fullwidth Latin letters and halfwidth katakana, so those count
// as CJK here. That is how this check has always behaved. See
// https://github.com/quanticedu/back_royal/pull/9264#discussion_r827310956
//
// Only `String.prototype.match` reads this pattern. `RegExp.prototype.test` would advance `lastIndex`
// on a global pattern and give a different answer on every other call.
const CJK_CHARACTERS = /[一-龥︰-ﾠ]/g;

/**
 * Whether more than half of the characters in the text are CJK.
 *
 * The application short-answer inputs ask for English, and this is the check behind that ask. It does
 * not detect English: it only rejects text that is mostly CJK. Spanish, Russian, Arabic and Korean all
 * pass. The name says CJK rather than English on purpose.
 *
 * The threshold counts UTF-16 code units. Every character in the ranges above is one code unit, so a
 * count of matches is comparable to `text.length`.
 */
export default function textIsMostlyCjk(text: string | null | undefined): boolean {
    if (!text) return false;

    const cjkCharacters = text.match(CJK_CHARACTERS);
    return !!cjkCharacters && cjkCharacters.length > text.length / 2;
}
